import { forwardRef, ReactNode } from "react";

import { SxProps } from "@mui/material";

import * as Styled from "./styles";

type TButtonType = "submit" | "reset" | "button";

type TGradientButton = {
  children: ReactNode;
  isOutlined?: boolean;
  isDisabled?: boolean;
  type?: TButtonType;
  onClick?: () => void;
  sx?: SxProps;
  isFullWidth?: boolean;
  isBigButton?: boolean;
  isIconButtonLike?: boolean;
  // Grey "disabled" look but still clickable (so onClick/submit can shake the
  // unmet required fields instead of the click being swallowed).
  isDimmed?: boolean;
  width?: number;
};

export const Button = forwardRef<HTMLButtonElement, TGradientButton>(
  (
    {
      children,
      isOutlined = false,
      isDisabled = false,
      type,
      sx,
      isFullWidth = false,
      isBigButton = false,
      isIconButtonLike = false,
      isDimmed = false,
      width,
      ...eventListeners
    },
    ref,
  ) => {
    return (
      <Styled.Button
        $isBigButton={isBigButton}
        $isOutlined={isOutlined}
        $isFullWidth={isFullWidth}
        $isIconButtonLike={isIconButtonLike}
        $dimmed={isDimmed}
        disabled={isDisabled}
        type={type}
        width={width}
        sx={sx}
        ref={ref}
        {...eventListeners}
      >
        {children}
      </Styled.Button>
    );
  },
);
